import { Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import { AbsoluteBox, StyledTypography, ToggleBox } from "../styles";
import { type ToggleIconProps } from "../interfaces";

const iconSx = (isSelected: boolean) => ({
  color: isSelected ? "neutral.0" : "neutral.600",
  fontSize: 10,
});

export const ToggleIcon = ({ isSelected, exclusive }: ToggleIconProps) => {
  if (exclusive) {
    return (
      <AbsoluteBox>
        <ToggleBox isSelected={isSelected} circle>
          {isSelected && <CheckIcon sx={iconSx(isSelected)} />}
        </ToggleBox>
      </AbsoluteBox>
    );
  }

  return (
    <AbsoluteBox>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <StyledTypography>
          {isSelected ? "selecionado" : "selecionar"}
        </StyledTypography>
        <ToggleBox isSelected={isSelected}>
          {isSelected ? (
            <CheckIcon sx={iconSx(isSelected)} />
          ) : (
            <AddIcon sx={iconSx(isSelected)} />
          )}
        </ToggleBox>
      </Stack>
    </AbsoluteBox>
  );
};
